<template>
    <div style="display: flex;align-items: center;">
        <img :src="jianIcon" alt="" style="width: 18px;height: 18px;cursor: pointer;" @mouseenter="jianEnter"
            @mouseleave="jianLeave" @click="jianFn">
        <input type="text" class="ipt" v-model="count" onkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')" @input="getCount">
        <img :src="jiaIcon" alt="" style="width: 18px;height: 18px;cursor: pointer;" @mouseenter="jiaEnter"
            @mouseleave="jiaLeave" @click="jiaFn">
    </div>
</template>
<script>
export default {
    name: 'inputNumber',
    props: {
        num: Number,
        max: Number
    },
    data() {
        return {
            jianIcon: require('../../../../assets/input/icon_jian_default@2x.png'),
            jiaIcon: require('../../../../assets/input/icon_jia_nor@2x.png'),
            count: 1
        }
    },
    watch: {
        "count": {
            handler(newVal, oldVal) {
                if (!newVal || newVal == 1) {
                    this.jianIcon = require('../../../../assets/input/icon_jian_default@2x.png')
                } else {
                    this.jianIcon = require('../../../../assets/input/icon_jian_nor@2x.png')
                }
                if (!newVal) {
                    this.jiaIcon = require('../../../../assets/input/icon_jia_default@2x.png')
                } else {
                    this.jiaIcon = require('../../../../assets/input/icon_jia_nor@2x.png')
                }
                if(this.max && newVal == this.max){
                    console.log('5555')
                    this.jiaIcon = require('../../../../assets/input/icon_jia_default@2x.png')
                }
                this.$emit('input',newVal)
            }
        }
    },
    created(){
        if(this.num){
            this.count = this.num;
        }
    },
    methods: {
        jianFn() {
            if (this.count && this.count > 1) {
                this.count--
            }
        },
        jiaFn() {
            if (this.count) {
                if(this.max && this.count == this.max){
                   return
                }
                
                this.count++
            }
        },
        getCount(e) {
            console.log(e.target.value)

        },
        jianEnter(e) {
            // let count = Number(this.count)
            if (this.count && this.count > 1) {
                this.jianIcon = require('../../../../assets/input/icon_jian_activate@2x.png')
            }

        },
        jianLeave(e) {
            if (this.count && this.count > 1) {
                this.jianIcon = require('../../../../assets/input/icon_jian_nor@2x.png')
            }

        },
        jiaEnter(e) {
            if (this.count) {
                if(this.max && this.count == this.max){
                    // this.jiaIcon = require('../../../../assets/input/icon_jia_default@2x.png')
                    return
                }
                this.jiaIcon = require('../../../../assets/input/icon_jia_activate@2x.png')
            }
        },
        jiaLeave(e) {
            if (this.count) {
                if(this.max && this.count == this.max){
                    // this.jiaIcon = require('../../../../assets/input/icon_jia_default@2x.png')
                    return
                }
                this.jiaIcon = require('../../../../assets/input/icon_jia_nor@2x.png')
            }
        },
    }
}
</script>
<style scoped lang="scss">
.ipt {
    width: 42px;
    height: 24px;
    background: #FFFFFF;
    border: 1px solid #D9D9D9;
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    color: #666;
    margin: 0 4px;
    padding: 0;
}
</style>